<div class="grid grid--gap-16" *ngIf="gpDopInfo$ | async as gpDopInfo">
  <div class="grid__box grid__box--size-min">
    <div class="grid grid--gap-4 grid--va-middle">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'clock2'" [size]="'16'" [color]="'gray'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        {{ gpDopInfo.global_problem.down_time_start | timeRange: gpDopInfo.global_problem.down_time_end }}
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-min">
    <div class="grid grid--gap-4 grid--va-middle">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'user'" [size]="'16'" [color]="'gray'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        {{ gpDopInfo.global_problem.affected_logins_count }}
      </div>
    </div>
  </div>
</div>
